import React, { Component } from 'react';
import "./VideoPopup.scss"
import FlowPlayer from '../../Services/Flowplayer/Flowplayer';
import { makeItM3U8 } from "../../Services/Flowplayer/m3u8"
import { mobile } from '../../Services/Agent';
import { push } from '../../Services/Analytics';

class VideoPopup extends Component {
    constructor(props) {
        super();
        this.state = {}
    }
    componentDidMount() {
        if (mobile()) {
            this.video.querySelector(".fp-fullscreen").click();
        }
    }
    render() {
        const videos = ["https://mediadownload.ynet.co.il/cdnwiz/0718/040718_yahel__fix_gilad2_lVuQ3HSN_1600_2HCZzb85_1600.mp4",
            "https://mediadownload.ynet.co.il/cdnwiz/0718/040718_nechushtan__fix_gilad2_rtHDhxAk_1600_WnQA5JeG_1600.mp4"];
        const Video = [
            {
                title: "",
                type: "video/mp4",
                src: videos[this.props.videoIndex]
            },
            {
                title: "",
                type: "application/x-mpegurl",
                src: makeItM3U8(videos[this.props.videoIndex])
            }
        ]
        // push("Video_play", videos[this.props.videoIndex]);
        return (
            <div className="video" ref={_video => this.video = _video}>
                <FlowPlayer list={Video} VideoName={videos[this.props.videoIndex]} />
            </div>
        );
    }
}

export default VideoPopup;



// WEBPACK FOOTER //
// ./src/Components/Helpers/Popup/VideoPopup.jsx